var _circle, _circle2, _circle3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#1AB25D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 49.6603,
    cy: 49.6603,
    r: 44.6603,
    fill: "#1AB25D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.1963,
    cy: 50.1963,
    r: 38.1963,
    fill: "#1AB25D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.2683 36.1689L67.2683 36.1689C66.7168 36.1853 66.1934 36.4155 65.8087 36.8108C65.8082 36.8113 65.8078 36.8117 65.8073 36.8122L42.9373 59.6822L33.1915 49.9364C32.9961 49.7333 32.7622 49.5712 32.5035 49.4593C32.244 49.3472 31.9647 49.2879 31.682 49.285C31.3993 49.2822 31.1188 49.3357 30.8571 49.4426L30.9516 49.674L30.8571 49.4426C30.5953 49.5495 30.3575 49.7075 30.1576 49.9074C29.9577 50.1073 29.7997 50.3451 29.6928 50.6068C29.586 50.8686 29.5324 51.149 29.5353 51.4317C29.5381 51.7144 29.5974 51.9937 29.7096 52.2533C29.8214 52.512 29.9835 52.7459 30.1866 52.9413L41.4349 64.1896L41.4349 64.1896C41.8334 64.588 42.3738 64.8117 42.9373 64.8117C43.5008 64.8117 44.0412 64.588 44.4397 64.1896L44.4398 64.1896L68.8123 39.817C68.8127 39.8166 68.8132 39.8162 68.8136 39.8157C69.12 39.5174 69.3292 39.1337 69.414 38.7146C69.4989 38.2948 69.455 37.8592 69.2881 37.4649C69.1212 37.0705 68.8391 36.7358 68.4787 36.5045C68.1182 36.2733 67.6964 36.1563 67.2683 36.1689Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.a1936a7f042909367c48b221d6ad083a.svg";
export { ForwardRef as ReactComponent };